// TicketListWrapper.jsx - Reusable wrapper for TicketList with optional heading and description
import React from "react";
import TicketList from "./TicketList";

const TicketListWrapper = ({
  tickets,
  ticketType,
  quantities,
  updateQuantity,
  isLoading,
  vehicleCapacity,
  vehicleCount,
  removeTicket,
  isScheduled,
  heading = "Select Your Tickets",
  description = "Choose the number of tickets for each time slot below.",
  showDescription = true,
  wrapperClass = "bg-white border border-gray-200 rounded-lg shadow-sm pt-2",
}) => {
  return (
    <div className={wrapperClass}>
      <h3 className="font-medium text-gray-900 mb-2 px-4">{heading}</h3>
      {showDescription && (
        <p className="text-sm text-gray-600 mb-2 px-4">{description}</p>
      )}
      <TicketList
        tickets={tickets}
        ticketType={ticketType}
        quantities={quantities}
        updateQuantity={updateQuantity}
        isLoading={isLoading}
        vehicleCapacity={vehicleCapacity}
        vehicleCount={vehicleCount}
        removeTicket={removeTicket}
        isScheduled={isScheduled}
      />
    </div>
  );
};

export default TicketListWrapper;